module.exports = __webpack_public_path__ + "static/media/preview6.ac6dc73e.png";